import ArenaProductsApi from '@/services/shop/ArenaProductsApi'
import type {
  ArenaProductInterface,
  ArenaProductTax,
  ArenaProductVariant,
} from '@/models/shop/ArenaProduct.types'

export type {
  ArenaProductInterface,
  ArenaProductTax,
  ArenaProductVariant,
} from '@/models/shop/ArenaProduct.types'

export class ArenaProductDTO implements ArenaProductInterface {
  id = ''
  arena_id = 0
  category_id = ''
  global_product_id = ''
  name = ''
  description = ''
  image = ''
  sort_order = 0
  track_stock = false
  created_at = ''
  updated_at = ''
  variants: ArenaProductVariant[] = []
  taxes: ArenaProductTax[] = []
}

export default class ArenaProduct extends ArenaProductDTO {
  static api = ArenaProductsApi

  constructor(DTO: ArenaProductDTO) {
    super()
    Object.assign(this, DTO)
  }
}
